import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './app';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker fuer Web Push Notifications registrieren
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then((registration) => {
      console.info('[SW] Service Worker registriert:', registration.scope);
    })
    .catch((err) => {
      console.warn('[SW] Service Worker Registrierung fehlgeschlagen:', err);
    });
}
